import { render } from "./NoData.vue?vue&type=template&id=00faaa60"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"

import "./NoData.vue?vue&type=style&index=0&id=00faaa60&lang=scss"

import exportComponent from "F:\\myCode\\团标平台（社会团体标准化专业人员公共服务平台）\\community-standard-front\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__